import { render, staticRenderFns } from "./FormMaxlen.vue?vue&type=template&id=c675643a&"
import script from "./FormMaxlen.vue?vue&type=script&lang=js&"
export * from "./FormMaxlen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports